const isCreateOrEditProduct = resource => resource === 'products';

const isCreateOrEditCustOptions = (resource, subResource) => resource === 'customizations' && subResource === 'options';
export {
  isCreateOrEditProduct,
  isCreateOrEditCustOptions,
};
